import { Container, Divider } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Grid } from "@mui/material";
import axios from "axios";
import {
  ButtonGroupTop,
  CustomTable,
  ModalError,
  ModalSuccess,
  Page,
  PrimaryButton,
  SearchTextInput,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import { getErrors } from "utils";
import ModalFormParameterTerritory from "./Components/ModalFormParameterTerritory";

function Territory() {
  const classes = globalStyles();
  const isFirstLoad = useRef(true);
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [loadingPage, setLoadingPage] = useState(true);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    size: 10,
    search: "",
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);
  const [optionCountry, setOptionCountry] = useState();
  const [modalVisible, setModalVisible] = useState(false);
  const [modalPreload, setModalPreload] = useState(null);

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };

  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(`${hardBaseUrl}/admin/territory`, {
        headers,
        params: queryParams,
      });
      const { data, meta } = res?.data;
      setDataTable(data || []);
      const pageCount = getTotalPage(meta?.total, queryParams?.size);
      setTableTotalPage(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const debounceDataTable = useCallback(
    debounce(() => {
      getDataTable();
    }, 500),
    [queryParams]
  );
  const getOptionCountry = async () => {
    try {
      const res = await axios.get(`${hardBaseUrl}/country/table`, {
        headers,
        params: {
          page: 1,
          per_page: -1,
        },
      });
      setOptionCountry(res?.data?.data || []);
    } catch (error) {
      ModalError(getErrors(error?.response));
    }
  };
  const handleDelete = async id => {
    try {
      setLoadingPage(true);
      await axios.delete(`${hardBaseUrl}/admin/territory/${id}`, {
        headers,
      });
      ModalSuccess("Succesfully delete society").then(() => getDataTable());
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };
  const fetchData = async () => {
    setLoadingPage(true);
    const promises = [getDataTable()];
    if (isFirstLoad.current) {
      promises.push(getOptionCountry());
    }
    try {
      await Promise.all(promises);
    } catch (error) {
      ModalError(error, "Error fetching data");
    } finally {
      setLoadingPage(false);
      isFirstLoad.current = false;
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (!isFirstLoad.current) {
      const isSearching = Boolean(queryParams?.search);
      if (isSearching) {
        debounceDataTable();
        return () => {
          debounceDataTable.cancel();
        };
      } else {
        getDataTable();
      }
    }
  }, [queryParams, debounceDataTable]);

  return (
    <Page className={classes.root} title="Territory">
      <Container maxWidth={false}>
        <HeaderTitle title="Parameter" breadcrumbData={breadcrumbData} />
        <ButtonGroupTop />
        <Divider className={classes?.flatDivider} />
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          my="16px"
        >
          <Grid item>
            <SearchTextInput
              placeholder="Search"
              value={queryParams?.search}
              onChange={e =>
                handleChangeQueryParams(e?.target?.value, "search")
              }
              disabled={loadingPage}
            />
          </Grid>
          <Grid item>
            <PrimaryButton
              label="Add Territory"
              onClick={() => {
                setModalPreload(null);
                setModalVisible(true);
              }}
              startIcon={<Add />}
              size="large"
              disabled={loadingPage}
            />
          </Grid>
        </Grid>
        <CustomTable
          isLoading={loadingPage}
          columnTable={columnTable}
          data={dataTable}
          page={queryParams?.page}
          pageSize={queryParams?.size}
          pageCount={tableTotalPage}
          handleChangePage={(_, page) => handleChangeQueryParams(page, "page")}
          handleChangePageSize={e =>
            handleChangeQueryParams(e?.target?.value, "size")
          }
          isHaveAction
          tooltipEdit="Update Territory"
          handleEdit={item => {
            setModalPreload(item?.id);
            setModalVisible(true);
          }}
          deleteConfirmation
          tooltipDelete="Delete Territory"
          deleteConfirmationKey="territory_name"
          handleDelete={item => handleDelete(item?.id)}
        />
        {modalVisible && (
          <ModalFormParameterTerritory
            open={modalVisible}
            onClose={() => setModalVisible(false)}
            getDataTable={getDataTable}
            optionCountry={optionCountry}
            preload={modalPreload}
          />
        )}
      </Container>
    </Page>
  );
}

const breadcrumbData = [
  {
    label: "Parameter",
    link: "/admin/parameter/territory",
  },
  {
    label: "Territory",
    active: true,
  },
];
const columnTable = [
  {
    name: "territory_name",
    title: "Territory Name",
  },
  {
    name: "territory_type_flag",
    title: "Territory Type",
  },
  {
    name: "territory_code",
    title: "TIS-A",
  },
  {
    name: "territory_ext_code",
    title: "TIS-A-EXT",
  },
  {
    name: "countries",
    title: "Country",
  },
];
export default Territory;
